// extracted by mini-css-extract-plugin
export const wrapper = "Books-module--wrapper--158c2";
export const container = "Books-module--container--30GYT";
export const bookOne = "Books-module--bookOne--hl-k8";
export const bookTwo = "Books-module--bookTwo--2kIQx";
export const bookImage = "Books-module--bookImage--2Nts_";
export const bookWrapper = "Books-module--bookWrapper--4UGYN";
export const bookTitle = "Books-module--bookTitle--22RHk";
export const bookSubtitle = "Books-module--bookSubtitle--m1Yam";
export const shape = "Books-module--shape--1CaJi";